import React from 'react';
import {useParams} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {Container} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import Layout from '../components/Layout';
import {prepareInitialTagBlogsState} from '../redux/slices/tag-blog';
import TaggedBlogsContainer from '../components/TaggedBlogs/TaggedBlogsContainer';

/**
 * A page that'll show the blog posts by tags
 */
function TaggedBlogs() {
  const {tag} = useParams();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(prepareInitialTagBlogsState(tag));
  }, [tag, dispatch]);

  return (
    <Layout>
      <Helmet>
        <title>{tag} Blogs | Khaaba</title>
      </Helmet>
      <Container maxWidth="md">
        <TaggedBlogsContainer tag={tag} />
      </Container>
    </Layout>
  );
}

export default TaggedBlogs;
